module.exports = __webpack_public_path__ + "img/couples-049.ba933c8b.jpg";